import * as React from "react";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import { ExistingDiscount, ExistingPromo, AddDiscount } from "../Invoices/DiscountReceiptItems";
import { ReceiptVewSummaryItem } from "../Invoices/ReceiptVewSummaryItem";
import { ReceiptViewLineItem } from "../Invoices/ReceiptViewLineItem";
import { EjiDiscount } from "../../generated/nest-graphql";
import { deriveTaxSource, isTaxTbc, taxLineLabel } from "../../lib/taxSource";
import {
  formValuesToEJIDiscountInputs,
  formValuesToEJIPromoCodeInputs,
  formValuesToPossibleEJIServiceInputs,
  formValueToEJIPricingConfigInput,
} from "../../specs/ejiServicesSpec";

export const ServicesReceiptView: React.FC<{
  stage;
  receiptValues;
  calculatePossibleEjiPriceInfo;
  services?;
  parentSubmitForm;
  taxable?: boolean;
}> = ({ receiptValues, calculatePossibleEjiPriceInfo, stage, services, parentSubmitForm, taxable = true }) => {
  const {
    subTotal = "--",
    partsTotal = "--",
    laborTotal = "--",
    feesTotal = "--",
    totalTax = "--",
    discounts = [],
    amountDue = "--",
    promoCodes = [],
  } = receiptValues;
  const taxSource = deriveTaxSource(receiptValues);

  return (
    <Card raised={true}>
      <CardContent>
        <ReceiptViewLineItem label={stage === "JOB" ? "Quoted Subtotal" : "Subtotal"} value={`$${subTotal}`} />
        <ReceiptViewLineItem subItem label={"Parts"} value={`$${partsTotal}`} />
        <ReceiptViewLineItem subItem label={"Labor"} value={`$${laborTotal}`} />
        {feesTotal && feesTotal !== "0.00" && <ReceiptViewLineItem subItem label={"Fees"} value={`$${feesTotal}`} />}
        <>
          {promoCodes.map((promo, promoIdx) => {
            return (
              <ExistingPromo
                promoCode={promo}
                key={promoIdx}
                discount={promo.coupon?.discount as EjiDiscount}
                discountIdx={promoIdx}
                calculatePossibleEJIPriceInfo={calculatePossibleEjiPriceInfo}
                stage={stage}
              />
            );
          })}
        </>
        <>
          {discounts.map((discount, discountIdx) => {
            return (
              <ExistingDiscount
                key={discountIdx}
                discount={discount}
                discountIdx={discountIdx}
                calculatePossibleEJIPriceInfo={calculatePossibleEjiPriceInfo}
                stage={stage}
                parentSubmitForm={parentSubmitForm}
              />
            );
          })}

          <AddDiscount
            calculatePossibleEJIPriceInfo={calculatePossibleEjiPriceInfo}
            stage={stage}
            services={services}
            parentSubmitForm={parentSubmitForm}
          />
        </>
        {/* Parts Tax Rate / Labor Tax Rate rows temporarily hidden pending product sign-off. */}
        <ReceiptViewLineItem
          label={taxLineLabel(taxSource, taxable)}
          value={isTaxTbc(taxSource, taxable) ? "TBC" : `$${totalTax}`}
        />
        <ReceiptVewSummaryItem label={"Total"} value={`$${amountDue}`} />
      </CardContent>
    </Card>
  );
};
